(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('WalletService', WalletService);

    WalletService.$inject = ['$resource'];

    function WalletService($resource) {

        //see wallet amount

        var getCustomerWalletByCustomerId = function (customerId) {
            var resourceUrl = 'api/customer-wallets/' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var addWalletBallanceByCustomerId = function (customerId) {
            var resourceUrl = 'api/customer-credits/'+ customerId ;
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST'}
                }
            );
        };

         var payWalletForCusomerByAdmin = function (customerId) {
            var resourceUrl = 'api/wallet/pay';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST'}
                }
            );
        };

        var getCreditOfCusomerId = function (customerId) {
            var resourceUrl = 'api/customer-credits/' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var deleteCredit = function (customerId, creditId) {
            var resourceUrl = 'api/customer-credits/' + customerId + '/' + creditId;
            return $resource(resourceUrl, {}, {
                    'delete': {method: 'DELETE', isArray: false}
                }
            );
        };


        return {
            getCustomerWalletByCustomerId: getCustomerWalletByCustomerId,
            addWalletBallanceByCustomerId: addWalletBallanceByCustomerId,
            payWalletForCusomerByAdmin: payWalletForCusomerByAdmin,
            getCreditOfCusomerId: getCreditOfCusomerId,
            deleteCredit: deleteCredit

        };
    }
})();
